// Panel names are usually "Panel 1 - …". A name without that prefix makes
// String.match return null; reading [1] threw and left the matrix table
// config undefined, so the Signatories list also threw reading columnDefs.

export function panelHeaderName(panel) {
    const name = typeof panel?.Name === "string" ? panel.Name : "";
    const panelNumber = name.match(/Panel (\d+)/)?.[1];
    if (panelNumber) return `Panel ${panelNumber}`;
    return name || "Panel";
}

export function buildPanelColumns(panels, { isMilitary = false } = {}) {
    return Object.entries(panels || {}).flatMap(([panelId, panel]) => {
        if (!panel || typeof panel !== "object") return [];

        const shouldHide = isMilitary
            ? (panel.MilitaryApproved === false)
            : (panel.STCApproved === false);

        return [{
            headerName: panelHeaderName(panel),
            type: "cve",
            field: `Panels.${panelId}.Answer`,
            minWidth: 85,
            width: 85,
            hide: shouldHide,
            headerTooltip: panel.Name,
        }];
    });
}
